export const environment = {
  production: true,
  baseURL: 'https://app.yourfill.it',
  backendUrl: 'http://localhost:3000',
  sessionsApiUrl: 'https://company-sessions.yourfill.it',
  n8nWebhookUrl: 'https://n8n.yourfill.it/webhook/67d883dd-8866-49ac-8851-b0545fca8c85',
  MAP_FRAME_PERC: 1,
  MAP_UPDATE_DEBOUNCE_MS: 200,
};
